"use strict"; ///////////////////////////////////////////////////////////////////////////////
//
// Licensed under the Apache License, Version 2.0  ( the  "License" );  you may 
// not use this file except in compliance with the License.  You may  obtain  a 
// copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required  by  applicable  law  or  agreed  to  in  writing,  software 
// distributed under the License is distributed on an "AS  IS"  BASIS,  WITHOUT
// WARRANTIES OR CONDITIONS  OF  ANY  KIND, either express or implied.  See the 
// License for the specific  language  governing  permissions  and  limitations 
// under the License.

var _classCallCheck = require("/home/user/RiderProjects/KernelManagementLab/Universe.W3Top/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/user/RiderProjects/KernelManagementLab/Universe.W3Top/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
}); //-----------------------------------------------------------------------------
//  CSharp Enumerator implementation
//-----------------------------------------------------------------------------
//  Gets Iterator and turns it into CSharpEnumerator 

var CSharpEnumerator =
/*#__PURE__*/
function () {
  function CSharpEnumerator(sourceIterator) {
    _classCallCheck(this, CSharpEnumerator);

    this._iterator = sourceIterator;
  }
  /** Gets the current element in the collection. */


  _createClass(CSharpEnumerator, [{
    key: "MoveNext",

    /** Advances the enumerator to the next element of the collection.*/
    value: function MoveNext() {
      this._result = this._iterator.next();
      return !this._result.done;
    }
    /** Sets the enumerator to its initial position, which is before the first
    * element in the collection. */

  }, {
    key: "Reset",
    value: function Reset() {
      throw "JavaScript iterators could not be Reset";
    }
  }, {
    key: "Current",
    get: function get() {
      return this._result.value;
    }
  }]);

  return CSharpEnumerator;
}();

exports.CSharpEnumerator = CSharpEnumerator;
/** Copyright (c) ENikS.  All rights reserved. */